module.exports = __webpack_public_path__ + "static/media/dramaImg7.88e7583c.jpg";